var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7778 10.2222H23.5556V8H12.4444V10.2222H10.2222C9 10.2222 8 11.2222 8 12.4444V13.5556C8 16.3889 10.1333 18.7 12.8778 19.0444C13.5778 20.7111 15.0778 21.9667 16.8889 22.3333V25.7778H12.4444V28H23.5556V25.7778H19.1111V22.3333C20.9222 21.9667 22.4222 20.7111 23.1222 19.0444C25.8667 18.7 28 16.3889 28 13.5556V12.4444C28 11.2222 27 10.2222 25.7778 10.2222Z",
    fill: "#2196F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.8ebcb1c57a6e08d988e984501b3d9479.svg";
export { ForwardRef as ReactComponent };